import Vue from 'vue'

//Apollo config
import VueApollo from '@vue/apollo-option'

//Apollo graphql config
import { ApolloClient, createHttpLink, InMemoryCache, ApolloLink} from '@apollo/client/core'
import { onError } from '@apollo/client/link/error'
import { logErrorMessages } from '@vue/apollo-util'

//Used to use async token validation in middleware
import { setContext } from '@apollo/client/link/context';

//Url service
import {NikitaPortalUrlFunct} from "@/UrlService.js"

//Authentication service
import {
  isTokenValid,
} from "@/components/auth/AuthService.js"

// HTTP connection to the nikita portal API
const httpLinkNikitaPortal = createHttpLink({
  // You should use an absolute URL here
  uri: NikitaPortalUrlFunct() + 'graphql',
})

//Auth middleware
const authMiddleware = setContext(async (headers) => {

  const access_token = await isTokenValid();  
  if(access_token != false){
    return {
      headers: {
        ...headers,
        authorization: `Bearer ${access_token}`,
      },
    }
  }
})

//Error handler
const errorLink = onError((error) => {
  logErrorMessages(error)
})

// Create the apollo client to SPQR charr
const apolloClientNikitaPortal = new ApolloClient({
  //Put in chain all this link
  link: ApolloLink.from([
    errorLink,
    authMiddleware,
    httpLinkNikitaPortal
  ]),
  cache: new InMemoryCache(),
});

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  //Define different API legs
  clients: {
    apolloClientNikitaPortal
  },
  defaultClient: apolloClientNikitaPortal,
  defaultOptions: {
    $query:{
      fetchPolicy: 'network-only',
    }
  }
})

export default apolloProvider;